export default __webpack_public_path__ + "static/1-3e9c5dfc11c4c630ba08c32716f3e8e1.png";